import type { App } from "vue"
import eventBus from "./events/event-bus"
import router from "./routers"
import store from "./store"

export interface ModuleRegisterFunction {
  (params: { app: App; store: typeof import("vuex")["Store"]; router: typeof router; eventBus: typeof eventBus }): void
}

export function registerModule(app: App, module: ModuleRegisterFunction) {
  module({ app, store, router, eventBus })
}
